import gql from 'graphql-tag';

import { consultationFragment } from '~/shared/graphql-queries/consultations/index';

export default gql`
  query findByIdConsultationQuery($_id: MongoID!) {
    findByIdConsultationQuery(_id: $_id) {
      ...ConsultationFragment
    }
  }
  ${consultationFragment}
`;
